var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "jp1psjl0ka"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.854279 0 0 0 0 0.870904 0 0 0 0 0.904155 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "",
    transform: "translate(-1231 -325) translate(1223 319)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1C2154",
    fillRule: "nonzero",
    d: "M3.5 2.65c.47 0 .85.38.85.85 0 .433-.324.79-.743.843L3.5 4.35h-2c-.47 0-.85-.38-.85-.85 0-.433.324-.79.743-.843L1.5 2.65h2zm15 0c.47 0 .85.38.85.85 0 .433-.324.79-.743.843l-.107.007H7.082c-.47 0-.85-.38-.85-.85 0-.433.324-.79.743-.843l.107-.007H18.5zM3.5 9.65c.47 0 .85.38.85.85 0 .433-.324.79-.743.843l-.107.007h-2c-.47 0-.85-.38-.85-.85 0-.433.324-.79.743-.843L1.5 9.65h2zm15 0c.47 0 .85.38.85.85 0 .433-.324.79-.743.843l-.107.007H7.082c-.47 0-.85-.38-.85-.85 0-.433.324-.79.743-.843l.107-.007H18.5zM3.5 16.65c.47 0 .85.38.85.85 0 .433-.324.79-.743.843l-.107.007h-2c-.47 0-.85-.38-.85-.85 0-.433.324-.79.743-.843l.107-.007h2zm15 0c.47 0 .85.38.85.85 0 .433-.324.79-.743.843l-.107.007H7.082c-.47 0-.85-.38-.85-.85 0-.433.324-.79.743-.843l.107-.007H18.5z",
    transform: "translate(8 6)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconList);
export default __webpack_public_path__ + "static/media/icon-list.764f0ee9.svg";
export { ForwardRef as ReactComponent };